import getMixedFileType from 'utils/getMixedFileType'

export default function filePropsSetterFactory(path, props) {
  function filePropsSetter({ state, resolve }) {
    const files = state.get(path)
    if (files) {
      const filter = state.get('media.filter')
      const filterThrough = file => {
        if (filter.active) {
          const fileType = getMixedFileType(file.extension)
          return filter.fileTypes[fileType].selected
        }
        return true
      }
      Object.keys(files).forEach(fileKey => {
        const file = files[fileKey]
        if (file[props.prop] !== props.value && !file.removed) {
          let value = props.value
          if (value) {
            value = filterThrough(file)
          }
          state.set(`${path}.${fileKey}.${props.prop}`, value)
        }
      })
    }
  }

  return filePropsSetter
}



// WEBPACK FOOTER //
// ./src/modules/Media/factories/filePropsSetter.js